import type { FC } from 'react';
import React, { Suspense, useCallback } from 'react';
import { Topics } from './topics';
import ErrorBoundary from 'view/error-boundary/error-boundary';
import { ScreenName } from 'view/common/constants';
import { useUFOComponentExperience } from '@atlassian/ufo';
import { helpCenterTopicsProductExperience } from './experiences';
import Loader from './loader';
import { isFetchNetworkOrClientError } from 'util/fetch';
import type { FetchError } from 'util/fetch';

interface Props {
    isDefaultViewLoading: boolean;
    shouldAlignWithHelpCenterContainer: boolean;
}

const HelpCenterTopics: FC<Props> = ({ isDefaultViewLoading, shouldAlignWithHelpCenterContainer }) => {
    useUFOComponentExperience(helpCenterTopicsProductExperience);

    const markExperienceFailed = useCallback((error: FetchError) => {
        if (!isFetchNetworkOrClientError(error)) {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            helpCenterTopicsProductExperience.failure({
                metadata: {
                    error: error.message,
                },
            });
        }
    }, []);
    return (
        <ErrorBoundary id={ScreenName.HELP_CENTER} packageName="topics" onError={markExperienceFailed}>
            <Suspense fallback={<Loader />}>
                <Topics
                    isDefaultViewLoading={isDefaultViewLoading}
                    shouldAlignWithHelpCenterContainer={shouldAlignWithHelpCenterContainer}
                />
            </Suspense>
        </ErrorBoundary>
    );
};

export default HelpCenterTopics;
